import axios from "axios";
import { BaseURL } from "./../api/index";

let baseURL = BaseURL;
const token = localStorage.getItem("token");
const AXIOS = axios.create({baseURL: `${baseURL}api`, headers: {Authorization: `Bearer ${token}`}});
const ApiInstance = () => {
    AXIOS.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                localStorage.clear();
                window.location.replace("/");
            }

            return Promise.reject(error);
        }
    );

    return AXIOS;
}

export const Api = ApiInstance();
export const ApiLogin = axios.create({ baseURL: `${baseURL}` });
export const ApiCep = axios.create({ baseURL: `${baseURL}api/cep/` });